var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newVue" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "text-xs-center" },
          [
            _c("v-progress-circular", {
              staticClass: "primary--text",
              attrs: { indeterminate: "", size: 100, width: 1 }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c("v-subheader", [
              _vm._v(
                _vm._s(
                  _vm.$tc("agents", _vm.agents.length, {
                    count: _vm.agents.length
                  })
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "v-expansion-panel",
              _vm._l(_vm.agents, function(agent, i) {
                return _c(
                  "v-expansion-panel-content",
                  { key: i },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "listeAgentsManagement",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _c("wz-avatar", {
                          attrs: {
                            username: agent.name,
                            src:
                              _vm.domaine +
                              "/public/media/user/small/" +
                              agent.id +
                              "_avatar.jpg",
                            size: "35px"
                          }
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(agent.name) +
                            "\n            " +
                            _vm._s(
                              _vm.isItMe(agent.id)
                                ? "(" + _vm.$t("me") + ")"
                                : ""
                            ) +
                            "\n          "
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "", sm6: "", lg3: "" } },
                                      [
                                        !_vm.isAdmin(agent.rights)
                                          ? _c("v-switch", {
                                              attrs: {
                                                label: agent.activity
                                                  ? "Le conseiller est activé"
                                                  : "Le conseiller est désactivé",
                                                color: "primary",
                                                disabled: _vm.isItMe(agent.id)
                                              },
                                              model: {
                                                value: agent.activity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    agent,
                                                    "activity",
                                                    $$v
                                                  )
                                                },
                                                expression: "agent.activity"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "", sm6: "", lg3: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.rights,
                                            label: _vm._f("cap")(
                                              _vm.$tc("rights", 2, {
                                                count: ""
                                              })
                                            ),
                                            "menu-props": "auto",
                                            disabled:
                                              _vm.isItMe(agent.id) &&
                                              _vm.isAdmin(agent.rights) &&
                                              !_vm.$store.state._User.entId !=
                                                "5"
                                          },
                                          model: {
                                            value: agent.rights,
                                            callback: function($$v) {
                                              _vm.$set(agent, "rights", $$v)
                                            },
                                            expression: "agent.rights"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "", sm6: "", lg3: "" } },
                                      [
                                        agent.isbot
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                      Le conseiller est un chatBot\n                    "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                agent.isbot
                                  ? _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", sm6: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Identité du chatbot"
                                              },
                                              model: {
                                                value: agent.firstname,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    agent,
                                                    "firstname",
                                                    $$v
                                                  )
                                                },
                                                expression: "agent.firstname"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs12: "",
                                              sm6: "",
                                              lg3: ""
                                            }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm._f("cap")(
                                                  _vm.$t("firstName")
                                                )
                                              },
                                              model: {
                                                value: agent.firstname,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    agent,
                                                    "firstname",
                                                    $$v
                                                  )
                                                },
                                                expression: "agent.firstname"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs12: "",
                                              sm6: "",
                                              lg3: ""
                                            }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm._f("cap")(
                                                  _vm.$t("lastName")
                                                )
                                              },
                                              model: {
                                                value: agent.lastname,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    agent,
                                                    "lastname",
                                                    $$v
                                                  )
                                                },
                                                expression: "agent.lastname"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "", lg6: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm._f("cap")(_vm.$t("job"))
                                          },
                                          model: {
                                            value: agent.job,
                                            callback: function($$v) {
                                              _vm.$set(agent, "job", $$v)
                                            },
                                            expression: "agent.job"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs12: "", lg6: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            disabled: "",
                                            label: _vm._f("cap")(
                                              _vm.$t("contactEmail")
                                            )
                                          },
                                          model: {
                                            value: agent.email,
                                            callback: function($$v) {
                                              _vm.$set(agent, "email", $$v)
                                            },
                                            expression: "agent.email"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !agent.isbot,
                                        expression: "!agent.isbot"
                                      }
                                    ]
                                  },
                                  [
                                    !_vm.isAdmin(agent.rights)
                                      ? _c(
                                          "span",
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  row: "",
                                                  wrap: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c("v-subheader", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("cap")(
                                                            _vm.$t("chatMax")
                                                          )
                                                        ) +
                                                          " : " +
                                                          _vm._s(agent.chatmax)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c("v-slider", {
                                                      attrs: {
                                                        disabled: _vm.testBrideStatus(
                                                          "compte_conseillers_chat_max"
                                                        ),
                                                        min: "1",
                                                        max: "4",
                                                        ticks: "",
                                                        "thumb-label": "",
                                                        "hide-details": ""
                                                      },
                                                      model: {
                                                        value: agent.chatmax,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            agent,
                                                            "chatmax",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "agent.chatmax"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.brideMenu(
                                              "compte_conseillers_transfert"
                                            ) === "1"
                                              ? _c(
                                                  "v-layout",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: true,
                                                        expression: "true"
                                                      }
                                                    ],
                                                    attrs: { row: "", wrap: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { xs12: "" } },
                                                      [
                                                        _c("v-subheader", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("cap")(
                                                                _vm.$t(
                                                                  "txtDelaiTransfert"
                                                                )
                                                              )
                                                            ) +
                                                              " : " +
                                                              _vm._s(
                                                                _vm.$tc(
                                                                  "minutes",
                                                                  agent.timeTransfert,
                                                                  {
                                                                    count:
                                                                      agent.timeTransfert
                                                                  }
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm._f("cap")(
                                                                  _vm.$t(
                                                                    "descriptionDelaiTransfert"
                                                                  )
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("v-slider", {
                                                          attrs: {
                                                            min: "0",
                                                            max: "60",
                                                            step: "1",
                                                            ticks: "",
                                                            "tick-size": "2",
                                                            "thumb-label": "",
                                                            "hide-details": ""
                                                          },
                                                          model: {
                                                            value:
                                                              agent.timeTransfert,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                agent,
                                                                "timeTransfert",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "agent.timeTransfert"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c("v-subheader", [
                                                      _vm._v(
                                                        "Temps de travail par jour : " +
                                                          _vm._s(
                                                            _vm.$tc(
                                                              "hours",
                                                              agent.tempsTravail,
                                                              {
                                                                count:
                                                                  agent.tempsTravail
                                                              }
                                                            )
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm._f("cap")(
                                                              _vm.$t(
                                                                "descriptionDelaiTempsTravail"
                                                              )
                                                            )
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c("v-slider", {
                                                      attrs: {
                                                        min: "2",
                                                        max: "16",
                                                        step: "0.5",
                                                        ticks: "",
                                                        "tick-size": "2",
                                                        "thumb-label": "",
                                                        "hide-details": ""
                                                      },
                                                      model: {
                                                        value:
                                                          agent.tempsTravail,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            agent,
                                                            "tempsTravail",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "agent.tempsTravail"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isAdmin(agent.rights)
                                      ? _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c("v-subheader", [
                                                  _vm._v(
                                                    "Jours ouvrés par semaine : " +
                                                      _vm._s(
                                                        _vm.$tc(
                                                          "days",
                                                          agent.jourHebdoTravail,
                                                          {
                                                            count:
                                                              agent.jourHebdoTravail
                                                          }
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("cap")(
                                                          _vm.$t(
                                                            "descriptionDelaiTempsTravail"
                                                          )
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c("v-slider", {
                                                  attrs: {
                                                    min: "1",
                                                    max: "7",
                                                    step: "1",
                                                    ticks: "",
                                                    "tick-size": "2",
                                                    "thumb-label": "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value:
                                                      agent.jourHebdoTravail,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        agent,
                                                        "jourHebdoTravail",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "agent.jourHebdoTravail"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isAdmin(agent.rights)
                                      ? _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c("v-subheader", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("cap")(
                                                        _vm.$t("priority") +
                                                          " (0 = normal, 10 = fort)"
                                                      )
                                                    ) +
                                                      " : " +
                                                      _vm._s(agent.priority)
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c("v-slider", {
                                                  attrs: {
                                                    disabled: _vm.testBrideStatus(
                                                      "compte_conseillers_prioritaire"
                                                    ),
                                                    min: "0",
                                                    max: "10",
                                                    ticks: "",
                                                    "thumb-label": "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: agent.priority,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        agent,
                                                        "priority",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "agent.priority"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                disabled: _vm.testBrideStatus(
                                                  "compte_conseillers_api"
                                                ),
                                                label: _vm._f("cap")(
                                                  "Tag / " + _vm.$t("keywords")
                                                )
                                              },
                                              model: {
                                                value: agent.keywords,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    agent,
                                                    "keywords",
                                                    $$v
                                                  )
                                                },
                                                expression: "agent.keywords"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                disabled: _vm.testBrideStatus(
                                                  "compte_conseillers_black_list"
                                                ),
                                                label: _vm._f("cap")(
                                                  "White List"
                                                )
                                              },
                                              model: {
                                                value: agent.parturl,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    agent,
                                                    "parturl",
                                                    $$v
                                                  )
                                                },
                                                expression: "agent.parturl"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                disabled: _vm.testBrideStatus(
                                                  "compte_conseillers_black_list"
                                                ),
                                                label: _vm._f("cap")(
                                                  "Black List"
                                                )
                                              },
                                              model: {
                                                value: agent.partnourl,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    agent,
                                                    "partnourl",
                                                    $$v
                                                  )
                                                },
                                                expression: "agent.partnourl"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isAdmin(agent.rights)
                                      ? _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c("v-switch", {
                                                  attrs: {
                                                    disabled: _vm.testBrideStatus(
                                                      "compte_conseillers_indispo"
                                                    ),
                                                    label: _vm._f("cap")(
                                                      _vm.$t("canBeUnavailable")
                                                    ),
                                                    color: "primary",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value:
                                                      agent.canBeUnavailable,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        agent,
                                                        "canBeUnavailable",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "agent.canBeUnavailable"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isAdmin(agent.rights)
                                      ? _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c("v-switch", {
                                                  attrs: {
                                                    disabled: _vm.testBrideStatus(
                                                      "compte_conseillers_notifbo"
                                                    ),
                                                    label: _vm._f("cap")(
                                                      _vm.$t("notification")
                                                    ),
                                                    color: "primary",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: agent.notifBo,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        agent,
                                                        "notifBo",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "agent.notifBo"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-xs-left" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          fab: "",
                                          dark: "",
                                          small: "",
                                          color: "error"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteAgent(
                                              agent.id,
                                              agent.name,
                                              agent.email,
                                              agent.index
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { dark: "" } }, [
                                          _vm._v("delete_forever")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-xs-right" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary", right: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.submit()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm._f("cap")(_vm.$t("save"))
                                            ) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "v-icon",
                                          { attrs: { dark: "", right: "" } },
                                          [_vm._v("send")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "v-fab-transition",
              [
                _c(
                  "v-tooltip",
                  { attrs: { left: "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.loading,
                            expression: "!loading"
                          }
                        ],
                        staticClass: "white--text",
                        attrs: {
                          slot: "activator",
                          fab: "",
                          bottom: "",
                          floating: "",
                          fixed: "",
                          raised: "",
                          right: "",
                          dark: "",
                          color: "secondary"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.openDialogCreate.apply(null, arguments)
                          }
                        },
                        slot: "activator"
                      },
                      [_c("v-icon", [_vm._v("add")])],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("cap")(_vm.$t("add"))) +
                          " " +
                          _vm._s(_vm.$tc("agents", 1, { count: "" }))
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dialog",
              {
                attrs: { persistent: "", "max-width": "290" },
                model: {
                  value: _vm.showDialogCreate,
                  callback: function($$v) {
                    _vm.showDialogCreate = $$v
                  },
                  expression: "showDialogCreate"
                }
              },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-title",
                      { staticClass: "primary white--text" },
                      [
                        _c("v-icon", { attrs: { dark: "" } }, [
                          _vm._v("person_add")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "title pl-2" }, [
                          _vm._v(
                            _vm._s(_vm._f("cap")(_vm.$t("add"))) +
                              " " +
                              _vm._s(_vm.$tc("agents", 1, { count: "" }))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-card-text", [
                      _c(
                        "form",
                        { attrs: { autocomplete: "on" } },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|max:20",
                                expression: "'required|max:20'"
                              }
                            ],
                            attrs: {
                              autofocus: "",
                              label: _vm._f("cap")(_vm.$t("firstName")),
                              counter: "",
                              required: "",
                              max: "20",
                              "data-vv-name": "fname",
                              autocomplete: "given-name"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.submitDialogCreate.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.newAgentDialog.fname,
                              callback: function($$v) {
                                _vm.$set(_vm.newAgentDialog, "fname", $$v)
                              },
                              expression: "newAgentDialog.fname"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "max:20",
                                expression: "'max:20'"
                              }
                            ],
                            attrs: {
                              autofocus: "",
                              label: _vm._f("cap")(_vm.$t("lastName")),
                              counter: "",
                              max: "20",
                              "data-vv-name": "lname",
                              autocomplete: "family-name"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.submitDialogCreate.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.newAgentDialog.lname,
                              callback: function($$v) {
                                _vm.$set(_vm.newAgentDialog, "lname", $$v)
                              },
                              expression: "newAgentDialog.lname"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              autofocus: "",
                              label: _vm._f("cap")(_vm.$t("loginEmail")),
                              counter: "",
                              required: "",
                              max: "30",
                              type: "email",
                              autocomplete: "email"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.submitDialogCreate.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.newAgentDialog.email,
                              callback: function($$v) {
                                _vm.$set(_vm.newAgentDialog, "email", $$v)
                              },
                              expression: "newAgentDialog.email"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|max:20",
                                expression: "'required|max:20'"
                              }
                            ],
                            attrs: {
                              autofocus: "",
                              label: _vm._f("cap")(_vm.$t("password")),
                              counter: "",
                              required: "",
                              max: "20",
                              type: "password",
                              "data-vv-name": "password",
                              autocomplete: "new-password"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.submitDialogCreate.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.newAgentDialog.pwd,
                              callback: function($$v) {
                                _vm.$set(_vm.newAgentDialog, "pwd", $$v)
                              },
                              expression: "newAgentDialog.pwd"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              label: _vm._f("cap")(
                                _vm.$tc("rights", 2, { count: "" })
                              ),
                              items: _vm.rights
                            },
                            model: {
                              value: _vm.newAgentDialog.rights,
                              callback: function($$v) {
                                _vm.$set(_vm.newAgentDialog, "rights", $$v)
                              },
                              expression: "newAgentDialog.rights"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { loading: _vm.loadingPost, flat: "" },
                            on: {
                              click: function($event) {
                                _vm.showDialogCreate = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("cancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _vm.loadingPost,
                              color: "primary",
                              flat: ""
                            },
                            on: { click: _vm.submitDialogCreate }
                          },
                          [_vm._v(_vm._s(_vm.$t("submit")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dialog",
              {
                attrs: { persistent: "", "max-width": "350" },
                model: {
                  value: _vm.dialogDelete,
                  callback: function($$v) {
                    _vm.dialogDelete = $$v
                  },
                  expression: "dialogDelete"
                }
              },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-title",
                      { staticClass: "primary white--text" },
                      [
                        _c("v-icon", { attrs: { dark: "" } }, [
                          _vm._v("delete")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "title pl-2" }, [
                          _vm._v("Suppression du conseiller")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-card-text", [
                      _c("p", [
                        _vm._v(
                          "Attention, vous êtes sur le point de supprimer définitivement la·le conseiller·ère " +
                            _vm._s(_vm.agentToDelName) +
                            " "
                        ),
                        _c("br"),
                        _c("br"),
                        _vm._v(_vm._s(_vm.agentToDelEmail)),
                        _c("br"),
                        _c("br"),
                        _vm._v(
                          "Toutes les références à ellui dans les conversations et les statistiques seront perdues."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { loading: _vm.loadingPost, flat: "" },
                            on: {
                              click: function($event) {
                                _vm.dialogDelete = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("cancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _vm.loadingPost,
                              color: "primary",
                              flat: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.submitDialogDelete(_vm.agentToDelId)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("submit")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56fca49a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56fca49a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/management/Agents.vue
// module id = null
// module chunks = 